/**
 * Lead student type: only explicit "internal" is internal; unset/empty/external → external.
 */
export const normalizeLeadStudentType = (leadStudentType) => (
  leadStudentType === 'internal' ? 'internal' : 'external'
);

const isPopulatedDoc = (value) => value && typeof value === 'object' && value._id != null;

const resolveFromLeadRefs = ({ leadId, studentId } = {}) => {
  if (isPopulatedDoc(leadId) && leadId.studentType !== undefined) {
    return normalizeLeadStudentType(leadId.studentType);
  }

  const linkedLead = isPopulatedDoc(studentId?.leadId) ? studentId.leadId : null;
  if (linkedLead && linkedLead.studentType !== undefined) {
    return normalizeLeadStudentType(linkedLead.studentType);
  }

  return null;
};

/**
 * Resolve student type from populated application refs (sync).
 * Lead (direct or via student.leadId) always wins over backend snapshot and student.studentType.
 */
export const resolveStudentTypeFromApplicationRefs = ({
  resolvedStudentType,
  leadId,
  studentId,
  allowStudentFallback = false
} = {}) => {
  const fromLead = resolveFromLeadRefs({ leadId, studentId });
  if (fromLead) {
    return fromLead;
  }

  if (resolvedStudentType === 'internal' || resolvedStudentType === 'external') {
    return resolvedStudentType;
  }

  if (allowStudentFallback && isPopulatedDoc(studentId) && studentId.studentType === 'internal') {
    return 'internal';
  }

  return 'external';
};
